import { useState } from 'react';
import { ChevronRight, Download, Network, Link2, Shield, Clock } from 'lucide-react';
import useSiteSetupStore from '../../../stores/siteSetupStore';
import fetchWithTenant from '../../../utils/fetchWithTenant';
import { useBranding } from '../../../contexts/BrandingContext';

const WelcomeStep = ({ onNext }) => {
  const { markStepComplete, tenant } = useSiteSetupStore();
  const { branding } = useBranding();
  const brandName = branding.brandName;
  const [starting, setStarting] = useState(false);

  const handleStart = async () => {
    setStarting(true);
    try {
      const res = await fetchWithTenant('/api/onboarding/provision-trials', { method: 'POST' });
      if (res.ok) {
        const data = await res.json();
        console.log('[WelcomeStep] Trials provisioned:', data.provisioned);
      } else {
        console.warn('[WelcomeStep] Provision trials response:', res.status);
      }
    } catch (err) {
      console.warn('[WelcomeStep] Trial provisioning error:', err.message);
    }

    await markStepComplete('welcome');
    setStarting(false);
    onNext();
  };

  return (
    <div className="site-setup-step welcome-step">
      <div className="welcome-hero">
        <h1>Welcome to {brandName}</h1>
        <p className="welcome-subtitle">
          Let's get <strong>{tenant?.name || 'your site'}</strong> set up. This wizard will walk you through
          connecting your security systems so everything works together in one place.
        </p>
      </div>

      <div className="welcome-phases">
        <div className="welcome-phase-card">
          <div className="welcome-phase-icon"><Download size={20} /></div>
          <div className="welcome-phase-info">
            <strong>Install Agent</strong>
            <span>Connect a monitoring agent to your network</span>
          </div>
        </div>
        <div className="welcome-phase-card">
          <div className="welcome-phase-icon"><Network size={20} /></div>
          <div className="welcome-phase-info">
            <strong>Discover Devices</strong>
            <span>Scan your network to find cameras, NVRs, and switches</span>
          </div>
        </div>
        <div className="welcome-phase-card">
          <div className="welcome-phase-icon"><Link2 size={20} /></div>
          <div className="welcome-phase-info">
            <strong>Connect Integrations</strong>
            <span>Link your VMS, access control, and intercoms</span>
          </div>
        </div>
        <div className="welcome-phase-card">
          <div className="welcome-phase-icon"><Shield size={20} /></div>
          <div className="welcome-phase-info">
            <strong>Recording Assurance</strong>
            <span>Verify your cameras are recording 24/7</span>
          </div>
        </div>
      </div>

      <div className="welcome-time">
        <Clock size={14} />
        <span>Takes about 10-15 minutes</span>
      </div>

      <div className="welcome-actions">
        <button className="site-setup-btn primary large" onClick={handleStart} disabled={starting}>
          {starting ? 'Setting up...' : "Let's Get Started"} {!starting && <ChevronRight size={18} />}
        </button>
      </div>
    </div>
  );
};

export default WelcomeStep;
